var globalArray = [];
export {globalArray}
var globalArray2 = [];
export {globalArray2}